import { useState } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { Container, Row, Col, ButtonGroup, ToggleButton } from 'react-bootstrap'
import { PlayFill, Shuffle } from 'react-bootstrap-icons'
import Spinner from '../../components/Spinner'

import {
  getChassisInfo,
  getChassisRecordingList,
  getAlbumUrl,
} from '../../api/api.cdlbt.co'
import RecordingTable from '../../components/user/RecordingTable'

import { useContext } from 'react'
import { PlayerContext } from '../../pages/Home'

const ChassisPage = () => {
  const { playRecordings } = useContext(PlayerContext)
  let { make, model } = useParams()

  const chassisRecordingList = useQuery({
    queryKey: ['playList', make, model],
    queryFn: getChassisRecordingList,
  })

  const chassisInfo = useQuery({
    queryKey: ['chassisInfo', make, model],
    queryFn: getChassisInfo,
  })

  // States for filtering recording by engine and gearbox
  const [engineRadioValue, setEngineRadioValue] = useState(0)
  const [gearboxRadioValue, setGearboxRadioValue] = useState(0)

  if (
    chassisRecordingList.isLoading ||
    chassisRecordingList.isError ||
    chassisInfo.isLoading ||
    chassisInfo.isError
  ) {
    return (
      <Container className='text-center'>
        <Spinner />
      </Container>
    )
  }

  let engineRadios = []
  let gearboxRadios = []

  chassisInfo.data.engineList.map((engine, index) => {
    engineRadios.push({
      name: `${engine.partMake.makeName} ${engine.partName}`,
      value: index,
    })
  })

  chassisInfo.data.gearboxList.map((gearbox, index) => {
    gearboxRadios.push({
      name: `${gearbox.partMake.makeName} ${gearbox.partName}`,
      value: index,
    })
  })

  const recordingList = chassisRecordingList.data.filter(
    (recording) =>
      recording.vehicle.engine.partId ==
        chassisInfo.data.engineList[engineRadioValue].partId &&
      recording.vehicle.gearbox.partId ==
        chassisInfo.data.gearboxList[gearboxRadioValue].partId
  )

  return (
    <Container>
      <Row className='ps-3 pe-3 flex-row'>
        <Col xs={4} className='ps-4 pe-4'>
          <Row className='flex-row d-flex w-100 mt-3 mb-3'>
            {chassisInfo.data.bodyList.map((body) => (
              <Col>
                <img
                  className={`rounded ${chassisInfo.data.makeId}`}
                  src={getAlbumUrl(body.partMake.makeId, body.partId)}
                  alt={body.partName}
                />
              </Col>
            ))}
          </Row>
          <Row className='w-100 mt-3 mb-3'>
            <h2 className='fw-bold'>
              {chassisInfo.data.makeName} {chassisInfo.data.full_name}
            </h2>
            <small>
              {chassisInfo.data.engineList.length} engine{' '}
              {chassisInfo.data.engineList.length > 1 ? 'types' : 'type'} -{' '}
              {chassisInfo.data.gearboxList.length} gearbox{' '}
              {chassisInfo.data.gearboxList.length > 1 ? 'types' : 'type'}
            </small>
            <small>{chassisRecordingList.data.length} clips</small>
          </Row>
          <Row>
            <Col className='d-flex'>
              <button
                className='playlist-play border-0 m-1 p-2 rounded-circle'
                onClick={() => playRecordings(chassisRecordingList.data)}
              >
                <PlayFill size={36} />
              </button>
              <button
                className='border-0 m-1 p-2 ps-3 pe-3 rounded-circle'
                onClick={() =>
                  playRecordings(shuffle(chassisRecordingList.data))
                }
              >
                <Shuffle size={20} />
              </button>
            </Col>
          </Row>
        </Col>
        <Col className='ps-4 pe-4'>
          <Row className='mb-2'>
            <ButtonGroup>
              {engineRadios.map((radio, index) => (
                <ToggleButton
                  key={index}
                  id={`engine-${index}`}
                  type='radio'
                  variant={'outline-primary'}
                  name='engineRadio'
                  value={radio.value}
                  checked={engineRadioValue === radio.value}
                  onChange={(e) =>
                    setEngineRadioValue(parseInt(e.currentTarget.value))
                  }
                >
                  {radio.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </Row>
          <Row className='mb-2'>
            <ButtonGroup>
              {gearboxRadios.map((radio, index) => (
                <ToggleButton
                  key={index}
                  id={`gearbox-${index}`}
                  type='radio'
                  variant={'outline-primary'}
                  name='gearboxRadio'
                  value={radio.value}
                  checked={gearboxRadioValue === radio.value}
                  onChange={(e) =>
                    setGearboxRadioValue(parseInt(e.currentTarget.value))
                  }
                >
                  {radio.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </Row>
          {recordingList.length > 0 ? (
            <RecordingTable
              hide={['chassis', 'gearbox']}
              recordingList={recordingList}
            />
          ) : (
            <>
              There are no results for the selected engine/gearbox
              configuration. Please choose another configuration.
            </>
          )}
        </Col>
      </Row>
    </Container>
  )
}
export default ChassisPage

/*  
  Randomize array in-place using Durstenfeld shuffle algorithm 
  https://stackoverflow.com/a/12646864 
*/
function shuffle(array) {
  let shuffledArray = array.slice()
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]
  }
  return shuffledArray
}
